import type { ColumnDef } from '@tanstack/react-table';
import { getMedicationStatus } from '@web-app/components/CallV2/MedicationsTab/medication-display';

export type MedicationRow = {
  id: string;
  name: string;
  dosage: string | null;
  isActive: boolean;
};

const EMPTY = '—';

function cellOrDash(value: string | null | undefined) {
  return value?.trim() ? value : EMPTY;
}

export const medicationsColumns: ColumnDef<MedicationRow>[] = [
  {
    accessorKey: 'name',
    header: 'Medication',
    cell: ({ row }) => (
      <span className="font-medium text-foreground">{row.original.name}</span>
    ),
  },
  {
    accessorKey: 'dosage',
    header: 'Dose',
    cell: ({ row }) => (
      <span className="text-foreground">
        {cellOrDash(row.original.dosage)}
      </span>
    ),
  },
  {
    id: 'status',
    accessorFn: (row) => getMedicationStatus(row.isActive),
    header: 'Status',
    cell: ({ row }) => {
      const status = getMedicationStatus(row.original.isActive);
      return (
        <span className="inline-flex items-center gap-1.5 text-foreground">
          <span
            className={
              row.original.isActive
                ? 'size-1.5 rounded-full bg-success'
                : 'size-1.5 rounded-full bg-muted-foreground'
            }
            aria-hidden
          />
          {status}
        </span>
      );
    },
  },
];
